import type { ReactNode } from 'react'

import { Container } from './Container'
import { Header } from './Header'

type Props = {
	title?: ReactNode
	children: ReactNode
}

export const List = ({ children, title }: Props) => (
	<Container showTopBorder={!title}>
		{title && <Header>{title}</Header>}
		{children}
	</Container>
)
